import React, { useState, useEffect } from "react";
import Pagination from '../../../../components/pagination/Pagination.jsx';
import columns from "../../../../columns/ib/MT5Account/MT5RejectAccount.js";
import TableWithSkeleton from '../../../../components/table/TableWithSkeleton.jsx';
import { GetAllAccountApi } from '../../../../api/request/liveAccount.js';
import moment from "moment";
import { useSelector } from "react-redux";

export default function Accounts({ searchText }) {

  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [data, setData] = useState([]);
  const [sorter, setSorter] = useState({ SortBy: 'createdDate', SortOrder: '' });

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.order) {
      setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
    } else {
      setSorter({ SortBy: 'createdDate', SortOrder: '' });
    }
  };

  const getDeclinedAccounts = async () => {
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        SearchText: searchText,
        FilterText: "Declined",
        ...sorter
      }
      setIsLoading(true);
      const { data } = await GetAllAccountApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              name: `${item?.firstName} ${item?.lastName}`,
              balance: `$ ${item?.balance}`,
              createdDate: (item?.createdDate ? moment(item?.createdDate).format("DD-MM-YYYY, hh:mm A") : null),
            };
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getDeclinedAccounts();
  }, [page, pageSize, searchText, filter, sorter]);

  return (
    <div className="w-full my-6">
      <div className="border border-gray-200 rounded-xl">
        <TableWithSkeleton columns={columns} data={data} loading={isLoading} onChange={handleTableChange} />
      </div>
      <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
    </div>
  )
}